module.exports = __webpack_public_path__ + "img/middletonLogo.2d58622a.png";